import { render, staticRenderFns } from "./Seguradora.vue?vue&type=template&id=bd3a4c4a"
import script from "./Seguradora.vue?vue&type=script&lang=js"
export * from "./Seguradora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports